import { P, pillSt } from '../theme/tokens';

export default function MetaChip({ color = P.subtle, title, children }) {
  return (
    <span title={title} style={pillSt(color, { fontSize: 11, padding: '2px 8px' })}>
      {children}
    </span>
  );
}
